<template>
<div class="m-portlet__body">
      <!--begin: Datatable -->
      <div
        id="m_table_1_wrapper"
        class="dataTables_wrapper dt-bootstrap4"
      >
        <div class="row">
          <div class="col-sm-12">
            <table
              class="table table-striped table-bordered table-hover table-checkable dataTable dtr-inline"
              id="m_table_1_child_segmentations"
              role="grid"
              style="width:4000px !important"
            >
              <thead>
                <tr role="row" class="thead-light">
                  <th
                    v-for="field in fields"
                    :key="field.id"
                  >{{ viewlabels[field.id] | capitalize }}</th>
                </tr>
              </thead>

            <tr class="filter" style="border-bottom: 2px solid">
              <th :key="'filter_' + field.id" v-for="(field, index) in fields" :data-column="index" class="rowFilter">
                    <select
                      name
                      :id="field.filterName"
                      :data-key="field.id"
                      multiple
                      v-if="field.searchType === 'multiChoice'"
                    ></select>

                    <input
                      type="text"
                      :id="`col${index}_filter`"
                      class="form-control m-input column_filter"
                      v-else-if="field.searchType === 'text'"
                    />
                  </th>
            </tr>
              <tbody>
                <tr
                    v-for="(data, index) in rawData"
                    :key="index">
                    <td
                    v-for="(value, subindex) in data"
                    :key="'value_'+index + '_' + subindex"
                    >
                      <template v-if="subindex === 0">
                        <span style="cursor:pointer" v-on:click="addThisFilterFacet(fields[0].facetFilters, data[0], null, null)">
                          {{ data[subindex] }}
                        </span>
                      </template>
                      <template v-else-if="Array.isArray(data[subindex])">
                        <ul>
                          <li
                            style="cursor:pointer"
                            v-for="(value2, index2) in data[subindex]"
                            v-on:click="addThisFilterFacet(fields[0].facetFilters, data[0], fields[subindex].facetFilters, value2.name)">{{ value2.name }} ({{ value2.count }}){{ index2 == data[subindex].length - 1 ? '' : '; '}}</li>
                        </ul>
                      </template>
                      <template v-else>{{ data[subindex]}}</template>
                    </td>
                </tr>
              </tbody>

            </table>

          </div>
        </div>
      </div>
      <!--end: Datatable -->
    </div>
</template>

<script>

import { mapState } from 'vuex';

import $ from 'jquery';
import dt from 'datatables.net';

export default {
  name: 'TableWithFilter',
  props: ['rawData', 'fields', 'viewlabels', 'facetFilters'],
  data() {
    return {
      table: null,
    };
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels,
    }),
  },
  methods: {
    filterColumn(i) {
      this.table.api().column(i).search($(`#col${i}_filter`).val()).draw();
    },
    addThisFilterFacet(mainFacetName, mainFacetValue, facetName, facetValue) {
      this.facetFilters.push(`${mainFacetName}:${mainFacetValue}`);
      if (facetName && facetValue) {
        this.facetFilters.push(`${facetName}:${facetValue}`);
      }

      const refinementList = {};
      const countIndex = {};
      this.facetFilters.forEach((facet) => {
        if (Array.isArray(facet)) {
          facet.forEach((subFacet) => {
            const splitedData = subFacet.split(':');

            if (!countIndex.hasOwnProperty(splitedData[0])) {
              countIndex[splitedData[0]] = 0;
            } else {
              countIndex[splitedData[0]]++;
            }

            refinementList[`refinementList[${splitedData[0]}][${countIndex[splitedData[0]]}]`] = splitedData[1];
          });
        } else {
          const splitedData = facet.split(':');
          if (!countIndex.hasOwnProperty(splitedData[0])) {
            countIndex[splitedData[0]] = 0;
          } else {
            countIndex[splitedData[0]]++;
          }

          refinementList[`refinementList[${splitedData[0]}][${countIndex[splitedData[0]]}]`] = splitedData[1];
        }
      });

      const queryString = Object.keys(refinementList).map((key) => `${key}=${refinementList[key]}`).join('&');

      this.$router.push(`/dashboard/manage-products?${encodeURI(queryString)}`);
    },
    initTable() {
      const my = this;

      const columnDefs = [];

      this.fields.forEach((field, index) => {
        const columnDef = {
          targets: index,
          orderData: field.orderData ? field.orderData : null,
          orderable: field.orderable,
        };
        if (field.width) {
          columnDef.width = field.width;
        } else {
          columnDef.width = '400px';
        }
        columnDefs.push(columnDef);
      });

      this.table = $('#m_table_1_child_segmentations').dataTable({
        order: [[1, 'desc']],
        columnDefs,
        paging: false,
        orderMulti: true,
        dom: 'lrtip',
        scrollX: true,
        scrollY: '700px',
        autoWidth: false,
      });

      $('input.column_filter').on('keyup click', function () {
        my.filterColumn($(this).parents('th').attr('data-column'));
      });
    },
  },
  updated() {
    this.$nextTick(() => {
      this.initTable();
    });
  },
};
</script>

<style scoped>
.rowFilter {
  border-bottom: 2px solid #f4f5f8
}

#m_table_1_child_segmentations td {
  vertical-align: top
}
</style>



// WEBPACK FOOTER //
// src/components/Table/TableWithFilter.vue